import { types, getParent } from "mobx-state-tree";
import shortid from 'shortid';
// import localforage from 'localforage';

// const store = localforage.createInstance({
//   name: 'materials'
// })

export default types
  .model({
    id: types.identifier(types.string),
    description: '',
    units: types.optional(types.enumeration(['each', 'metre', 'sheet']), 'each'),
    stockLength: types.maybe(types.number),
    sheetSizeX: types.maybe(types.number),
    sheetSizeY: types.maybe(types.number),
    unitCost: types.optional(types.number, 0),
    supplier: '',
    comment: '',
  })
  .preProcessSnapshot(snapshot => {
    const copy = Object.assign(snapshot)
    if (!copy.id) copy.id = shortid.generate()
    return copy
  })
  .actions(self => ({
    save() {
      // store.setItem(self.id, getSnapshot(self))
      getParent(self, 2).saveItem(self)
    },
    setDescription(value) { self.description = value },
    setSupplier(value) { self.supplier = value },
    setComment(value) { self.comment = value },
    setUnits(value) {
      self.units = value
      if (value === 'sheet') {
        self.stockLength = null
        self.sheetSizeX = 2.438
        self.sheetSizeY = 1.219
      }
    },
    setStockLength(value) {
      self.stockLength = value
    },
    setSheetSizeX(value) {
      self.sheetSizeX = value
    },
    setSheetSizeY(value) {
      self.sheetSizeY = value
    },
    setUnitCost(value) {
      self.unitCost = value
    },
  }))
  .views(self => ({
    get isValid() {
      if (self.units === 'sheet') {
        if (!(self.sheetSizeX > 0)) return false;
        if (!(self.sheetSizeY > 0)) return false;
      }
      if (isNaN(parseFloat(self.unitCost))) return false;
      return self.description.length > 0 && self.units.length > 0;
    },
    get costAsString() {
      var string = '$'
      string += self.unitCost.toFixed(2)
      string += self.units === 'each' ? ' each' : ' per ' + self.units
      return string
    },
    get unitDimensionsAsString() {
      var string
      if (self.units === 'sheet') {
        string = self.sheetSizeX + ' x ' + self.sheetSizeY
      } else if (self.units === 'metre' && self.stockLength > 0) {
        string = self.stockLength + 'm lengths'
      }
      return string || ''
    },
    get costAsStringWithDimensions() {
      var string = self.costAsString
      if (self.units === 'sheet') {
        string += (' (' + self.sheetSizeX + ' x ' + self.sheetSizeY + ')')
      } else if (self.units === 'metre' && self.stockLength > 0) {
        string += (' (' + self.stockLength + 'm lengths)')
      }
      return string
    },
    get isFixedLength() {
      return self.units === 'metre' && self.stockLength > 0
    }
}))


// WEBPACK FOOTER //
// ./src/models/Material.js